import { render, staticRenderFns } from "./tuidang.vue?vue&type=template&id=0af1ced2&scoped=true"
import script from "./tuidang.vue?vue&type=script&lang=js"
export * from "./tuidang.vue?vue&type=script&lang=js"
import style0 from "./tuidang.vue?vue&type=style&index=0&id=0af1ced2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1ced2",
  null
  
)

export default component.exports